import { useEffect, useRef, useState } from "react"
import replaceFilterValueParameter from "./ReplaceFilterValueParams"
import { TGetFilterVal } from "./GenericFilters"
import { IBusinessParamsOptions } from "../Reports/VisualUnitParamsDialog"
import { FoundationsConstants } from "../../FoundationsConstants"

const FilterItemMapper = ({
    filterValue,
    filterableId,
    bpdropDownOptions,
    currentHLDataType,
    isBusinessParameterReplace,
    GetFilterValues,
    selectedItem,
    setSelectedId,
    selectedParameters,
    MetadataId
}: {
    filterValue: any
    filterableId: any
    bpdropDownOptions: IBusinessParamsOptions[]
    currentHLDataType: any
    isBusinessParameterReplace: 0 | 1
    GetFilterValues: (filterValArgs: TGetFilterVal) => void
    selectedItem: number | null
    setSelectedId: any,
    selectedParameters: any,
    MetadataId: number
}) => {
    const listItemId = `filtervalue_item_${filterValue.KeyValue}`
    const replacedStr = replaceFilterValueParameter(
        filterValue.DisplayText,
        listItemId,
        isBusinessParameterReplace,
        bpdropDownOptions,
        currentHLDataType,
        filterableId,
        filterValue.KeyValue,
        GetFilterValues,
        selectedItem,
        selectedParameters,
        MetadataId
    )
    const handleItemClick = () => {
        setSelectedId(filterValue.KeyValue)
    }

    return (
        (isBusinessParameterReplace && FoundationsConstants.DonotDisplayFilterValues.includes(filterValue.DisplayText as string)) ? null : // WarRoom-28Apr2025 Do not display filter values if it is a business parameter and the displayValue is in the do not display list
        <li onClick={()=>handleItemClick()} id={listItemId} 
        className={`d-flex ${selectedItem == filterValue.KeyValue ? 'selected' : 'not-selected'}`}
        style={{ display: 'flex', width: '100%', position: 'relative' }}
        >
            <div className="float-left fieldradio" style={{ alignSelf: 'flex-start', marginTop: '3px', position: 'absolute', }}>
                <input
                    type="radio"
                    id={`filtervalue_radio_${filterValue.KeyValue}`}
                    name="filtervalue_radio"
                    checked={selectedItem == filterValue.KeyValue}
                    onChange={(e) => e.stopPropagation()}
                    style={{ verticalAlign: 'middle' }}
                />
                </div>
                <div className="float-left fieldcontent"
                    style={{
                        flex: 1,
                        paddingLeft: '20px', // Fixed space for radio button
                        overflow: 'visible',

                    }}>
                {replacedStr || ''}
            </div>
            <div className="clear-both"></div>
        </li>
    )
}

export default FilterItemMapper


